import React from "react";
import { useFormikContext } from "formik";

import PropTypes from "prop-types";
import Template from "../Template";
import ShortUrls from "./ShortUrls";
import MessageRcs from "../rcs/Message";
import MessageText from "../rcs/MessageText";
import { MessageChat } from "../rcs/DevicePreview";

const MessageSimpleRcs = ({ step }) => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <div className="bg-white py-3 rounded-lg">
      <div className="px-4">
        <div className="flex justify-between items-center">
          <div className="flex items-end gap-2 my-2">
            <div className="flex items-center justify-center size-8 rounded-full bg-[#009CFF] text-white">
              <span className="font-bold">{step}</span>
            </div>
          </div>
        </div>
        <div className="border rounded-lg">
          <div className="grid grid-cols-12">
            <div className="col-span-8">
              <MessageRcs />
            </div>
            <div className="col-span-4">
              <div className="text-md font-semibold py-3 mx-1">
                Previsualización
              </div>
              <MessageChat />
            </div>
          </div>

          <div className="border rounded-lg m-1"></div>
          <div className="grid grid-cols-2 gap-4">
            <Template
              onChange={(e) => setFieldValue("rcsmessage", e)}
              value={values.rcsmessage}
            />
            <ShortUrls
              onChange={(e) => setFieldValue("rcsmessage", e)}
              value={values.rcsmessage}
            />
          </div>
        </div>

        <div className="border rounded-lg mt-2">
          <MessageText />

          <div className="border rounded-lg m-1"></div>
          <div className="grid grid-cols-2 gap-4">
            <Template
              onChange={(e) => setFieldValue("fallback", e)}
              value={values.fallback}
            />
            <ShortUrls
              onChange={(e) => setFieldValue("fallback", e)}
              value={values.fallback}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

MessageSimpleRcs.propTypes = {
  step: PropTypes.number,
};

export default MessageSimpleRcs;
